import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { WithdrawalReceiptPageRoutingModule } from './withdrawal-receipt-routing.module';

import { WithdrawalReceiptPage } from './withdrawal-receipt.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    WithdrawalReceiptPageRoutingModule
  ],
  declarations: [WithdrawalReceiptPage]
})
export class WithdrawalReceiptPageModule {}
